import { createApp } from 'vue'
import { createPinia } from 'pinia';
import axios from 'axios'
import App from './App.vue'
import router from './router'
import { useAuthStore } from './stores/auth';
import { url } from '@/config/urls';
import pushNotificationService from '@/services/pushNotificationService';
import {
  isNetworkError,
  redirectToOfflineError,
} from '@functions/offlineReturnPath';

// Axiosのグローバル設定を追加
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.timeout = 10000;

axios.interceptors.request.use(config => {
  // Get/Head/Options以外のリクエストにCSRFトークンを追加
  if (!['get', 'head', 'options'].includes(config.method?.toLowerCase())) {
    const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {});
    
    const token = cookies['XSRF-TOKEN'];
    
    if(token) {
      config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token);
    }
  }
  return config;
}, error => {
  return Promise.reject(error);
});

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);

// 別タブのログイン、ログアウトによるセッション上書きに気づかず操作するのを防ぐためリロードする
window.addEventListener('storage', (e) => {
  if (e.key === 'auth:changed') {
    window.location.reload();
  }
});

router.isReady().then(() => {
  pushNotificationService.registerTapHandler(router);
});

// グローバルエラーハンドラ
axios.interceptors.response.use(
  response => response,
  async err => {
    // 認証状態の確認のように401が想定内の応答となるリクエストは、
    // skipAuthRedirect を付けてログイン画面への遷移対象から除外する
    if (err.response?.status === 401 && !err.config?.skipAuthRedirect) {
      const auth = useAuthStore();

      if (auth.isLoggingOut) {
        return Promise.reject(err);
      }
      auth.user = null;
      auth.initialized = false;

      if (!window.location.pathname.startsWith('/front/login')) {
        window.location.href = url.login;
      }

      return Promise.reject(err);
    }

    if (isNetworkError(err) && !err.config?.skipOfflineRedirect) {
      await redirectToOfflineError(router, router.currentRoute.value.fullPath);
    }

    return Promise.reject(err);
  }
);

app.mount('#app');
